import React, { useEffect, useRef } from 'react';
import '../styles/PowerYoga.css';
import yogaImage from '../assets/image1.jpg';

function PowerYoga() {
  const contentRef = useRef();
  
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    // Store the current ref value to avoid the cleanup warning
    const currentRef = contentRef.current;

    if (currentRef) {
      currentRef.style.opacity = '0';
      currentRef.style.transform = 'translateY(30px)';
      currentRef.style.transition = 'all 0.6s ease';
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, []);

  const smoothScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="power-yoga" id="power-yoga">
      <div className="container">
        <div className="power-yoga-grid">
          <div className="power-yoga-content" ref={contentRef}>
            <h3>Power Yoga & Vinyasa Flow</h3>
            <p>Experience the transformative power of dynamic yoga sequences that build strength, flexibility, and inner peace. Our Power Yoga classes combine traditional poses with modern flow techniques.</p>
            
            <ul className="power-yoga-features">
              <li>Strength-building power sequences</li>
              <li>Fluid vinyasa flow transitions</li>
              <li>Breath-synchronized movement</li>
              <li>Core-focused alignment</li>
              <li>Mindful meditation integration</li>
              <li>Beginner to advanced modifications</li>
            </ul>
            
            <p>Whether you're new to yoga or an experienced practitioner, our classes offer the perfect balance of challenge and accessibility.</p>
            
            <a 
              href="#ai-chat" 
              className="btn btn-primary"
              onClick={(e) => smoothScroll(e, '#ai-chat')}
            >
              Get Personalized Practice
            </a>
          </div>
          
          <div>
            <img 
              src={yogaImage} 
              alt="Power Yoga Practice" 
              className="yoga-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default PowerYoga;
